'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import usePlatform from '@haaretz/s-atoms/platform';
import { htzHostnames } from '@haaretz/s-consts';
import breakUrl from '@haaretz/s-url-utils/breakUrl';
import isNextLink from '@haaretz/s-url-utils/isNextLink';
import Link, { useLinkStatus } from 'next/link';
import * as React from 'react';
import { usePageLoaderUpdater } from '@haaretz/s-htz-link/PageLoaderProvider';
function PageLoaderUpdator() {
    const { pending } = useLinkStatus();
    const { togglePageLoader } = usePageLoaderUpdater();
    React.useEffect(()=>{
        togglePageLoader(pending);
    }, [
        pending,
        togglePageLoader
    ]);
    return null;
}
export default function HtzLinkComponent({ ref: forwardedRef, children = null, href, hrefAs, locale, prefetch = false, replace, scroll, shallow, onClick, ...attrs }) {
    const platform = usePlatform();
    const overrideAttrs = {};
    const { setNextUrl } = usePageLoaderUpdater();
    function onClickHandler(event) {
        if (typeof onClick === 'function') {
            onClick(event);
        }
        if ('onLine' in navigator && !navigator.onLine) {
            event.preventDefault();
            event.stopPropagation();
            setNextUrl(hrefAs?.toString() || href.toString());
        }
    }
    if (typeof href !== 'string' && !href?.href) {
        console.warn('The "href" prop you passed <HtzLink /> is a "URL" object without an "href" field:', href, '\nOpting out of rendering the element');
        // eslint-disable-next-line no-console
        console.trace();
        return null;
    }
    if (isNextLink(href, platform)) {
        return /*#__PURE__*/ _jsxs(Link, {
            as: hrefAs,
            href: href,
            locale: locale,
            prefetch: prefetch,
            replace: replace,
            scroll: scroll,
            shallow: shallow,
            referrerPolicy: hrefAs ? 'unsafe-url' : undefined,
            onClick: onClickHandler,
            ...attrs,
            ...overrideAttrs,
            ref: forwardedRef,
            children: [
                /*#__PURE__*/ _jsx(PageLoaderUpdator, {}),
                children
            ]
        });
    }
    const url = typeof href === 'string' ? href : href?.href || undefined;
    const { hostname: urlHostname } = breakUrl(url ?? '');
    const isHtzLink = htzHostnames.some((host)=>urlHostname.includes(host));
    if (isHtzLink || url?.startsWith('#')) {
        overrideAttrs['data-google-interstitial'] = false;
    }
    return /*#__PURE__*/ _jsx("a", {
        href: url,
        ...attrs,
        ...overrideAttrs,
        onClick: onClickHandler,
        ref: forwardedRef,
        children: children
    });
}

//# sourceMappingURL=HtzLink.js.map